<template>
  <div id="search-form-box">
    <div class="loading-box" v-if="showLoading">
      <loading></loading>
    </div>
    <div class="search-form-box-content">
      <h2 class="main-event-title">{{ main_event_title }}</h2>
      <p class="play-date-search-title">開催日</p>
      <div class="play-dates-list">
        <ul class="play-dates-list-ul">
          <li v-for="(play_date, index) in play_dates" :key="index">
            <label class="play-dates-list-label">
              <input type="checkbox" class="play-date-checkbox" :ref="'play-date-checkbox-' + index" v-model="selectedPlayDates" :value="play_date.play_date_val" /><span class="play-date" :ref="'play-date-' + index">{{ play_date.play_date_lbl }}</span>
            </label>
          </li>
        </ul>
      </div>
      <p class="ticket-type-search-title">チケット</p>
      <div class="ticket-search-forms" v-for="(form, index) in forms" :key="index">
        <select v-model="form.selectedTicketTypes" v-if="index === 0 || !has_ticket_type_all" @change="set_ticket_type_all" :class="{ 'ticket-search-form c-input__select': true, 'last-form': index === forms.length - 1 }">
          <option value="" v-if="1 > index">すべてのチケット</option>
          <option v-for="(ticket_type, index) in ticket_types" :value="ticket_type" :key="index">
            {{ ticket_type.name }}
          </option>
        </select>
        <div class="action-btns" v-if="!has_ticket_type_all">
          <button class="form-delete-btn" v-if="forms.length != 1 && index != 0" @click="deleteTicketSearchForm(index)">削除</button>
          <button class="form-add-btn" v-if="index === forms.length - 1 && index < ticket_types.length - 1" @click="addTicketSearchForm">チケット追加</button>
        </div>
      </div>
      <p class="word-search-title">ワード検索</p>
      <div class="word-and-search">
        <input class="c-input_text_area word-search-form" placeholder="メール、ニックネーム、受付番号など" v-model="inputedSearchWord" />
        <div class="word-and-search-btns">
          <button class="search-form-submit" @click="getAudiences">検索</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from './curation/CurationLoading.vue';

export default {
  props: {
    main_event_id: { type: Number, required: true },
    main_event_title: { type: String, required: true },
    play_dates: { type: Array, required: true },
    ticket_types: { type: Array, required: true },
    get_audiences_path: { type: String, required: true }
  },

  data() {
    return {
      forms: [{ selectedTicketTypes: '' }],
      selectedPlayDates: [],
      inputedSearchWord: '',
      has_ticket_type_all: true,
      showLoading: false,
      isAssistantAdmissionPage: false,
    };
  },
  computed: {
    currentPage: function () {
      return this.$store.getters['audience/getCurrentPage'];
    },
  },
  methods: {
    addTicketSearchForm() {
      this.forms.push({ selectedTicketTypes: this.forms[0].selectedTicketTypes });
    },
    deleteTicketSearchForm(index) {
      this.forms.splice(index, 1);
    },
    set_ticket_type_all() {
      const ticket_type_all = this.forms.find((form) => form.selectedTicketTypes === '');
      if (ticket_type_all) {
        this.has_ticket_type_all = true;
        this.forms = [{ selectedTicketTypes: '' }];
      } else {
        this.has_ticket_type_all = false;
      }
    },
    async getAudiences() {
      this.showLoading = true;
      this.setIsAssistantAdmissionPage();
      let isAdmissionPage = false;
      if (location.pathname.includes('/audience_list_admission') && !location.pathname.includes('/programs')) {
        isAdmissionPage = true;
      };
      this.$store.commit('audience/setPlayDates', this.selectedPlayDates);
      const selectedTicketTypes = this.forms.map((form) => form.selectedTicketTypes);
      this.$store.commit('audience/setTicketTypes', selectedTicketTypes);
      this.$store.commit('audience/setSearchWord', this.inputedSearchWord);

      // 1ページ目の場合はaudiencesを取得
      // それ以外の場合はcurrentPageを書き換える(書き換え先でaudiencesを取得)
      if (this.currentPage == 1) {
        await this.$store.dispatch('audience/getAudiences', { api_path: this.get_audiences_path, t: '', isAdmissionPage, is_assistant_admission_page: this.isAssistantAdmissionPage }).catch((error) => {
          alert('エラーが発生しました。時間をおいてから改めてお試しください。');
        });
      } else {
        this.$store.commit('audience/setCurrentPage', 1);
      }
      this.showLoading = false;
    },
    setIsAssistantAdmissionPage() {
      const currentPath = window.location.pathname;
      if (currentPath.endsWith('audience_list_admission')) {
        this.isAssistantAdmissionPage = false;
      } else {
        this.isAssistantAdmissionPage = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

#search-form-box {
  padding: 26px 30px 20px;
  background: $shop-input-gray;
  line-height: 1em;

  @media screen and (max-width: $break-point) {
    padding: 20px;
  }

  .main-event-title {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 20px;
    text-align: left;
    color: $shop-navy;
    font-size: 18px;
    font-weight: 600;
    line-height: 1em;

    @media screen and (max-width: $break-point) {
      font-size: 16px;
    }
  }

  .play-date-search-title {
    max-width: 100%;
    text-align: left;
    color: $shop-navy;
    margin-bottom: 15px;
    line-height: 1em;
    font-size: 13px;
    font-weight: 600;

    @media screen and (max-width: $break-point) {
      margin-bottom: 10px;
    }
  }

  .play-dates-list {
    max-width: 100%;

    .play-dates-list-ul {
      display: flex;
      flex-wrap: wrap;
      row-gap: 15px;

      @media screen and (max-width: $break-point) {
        row-gap: 10px;
      }
    }

    li {
      width: 173px;
      pointer-events: none;
    }

    .play-dates-list-label {
      display: flex;
      align-items: center;
      margin: 0;
      margin-right: 20px;
      cursor: pointer;

      @media screen and (max-width: $break-point) {
        margin-bottom: 10px;
      }

      .play-date {
        font-size: 15px;
        font-weight: 300;
        pointer-events: auto;
        padding-left: 10px;
      }
    }

    .play-date-checkbox {
      background: $shop-disable-gray;
      border: 1px solid $shop-border-gray;
      border-radius: 4px;
      position: relative;
      outline: none;
      margin-right: 0;
      cursor: pointer;
      pointer-events: auto;

      &:checked::before {
        content: '';
        position: absolute;
        top: 1px;
        left: 2px;
        width: 11px;
        height: 7px;
        border-left: solid 2px #fff;
        border-bottom: solid 2px #fff;
        transform: rotate(-39deg);
        background-color: transparent;
      }

      &::after {
        display: none;
      }
    }

    .play-date-checkbox:checked {
      background: $shop-blue;
    }
  }

  .ticket-type-search-title {
    max-width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    color: $shop-navy;
    font-size: 13px;
    font-weight: 600;

    @media screen and (max-width: $break-point) {
      margin-top: 10px;
    }
  }

  .ticket-search-forms {
    letter-spacing: -0.4em;

    .ticket-search-form {
      max-width: 800px;
      width: calc(100% - 170px);
      height: 38px;
      background: #fff;
      border: 1px solid $shop-lightgray;
      border-radius: 4px;
      color: $shop-navy;
      margin-bottom: 5px;
      cursor: pointer;

      &.last-form {
        margin-bottom: 0;
      }

      @media screen and (max-width: $break-point) {
        width: 100%;
        margin-bottom: 0;
      }
    }

    .action-btns {
      display: inline;
      font-size: 0;

      @media screen and (max-width: $break-point) {
        width: 100%;
        text-align: right;
        display: inline-block;
        margin-top: 10px;
        line-height: 1em;
      }

      .form-delete-btn {
        border: none;
        background-color: transparent;
        margin-left: 24px;
        padding: 0;
        width: 30px;
        height: 20px;
        color: $shop-red;
        font-size: 15px;

        @media screen and (max-width: $break-point) {
          margin-left: 0;
        }
      }

      .form-add-btn {
        border: none;
        background-color: transparent;
        width: 90px;
        height: 20px;
        padding: 0;
        margin-left: 22px;
        color: $shop-blue;
        font-size: 15px;
      }
    }
  }

  .word-search-title {
    max-width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    color: $shop-navy;
    font-size: 13px;
    font-weight: 600;
  }

  .word-and-search {
    display: flex;

    @media screen and (max-width: $break-point) {
      display: inline-block;
      width: 100%;
    }

    .word-search-form {
      width: 591px;
      height: 40px;
      background: #fff;
      border: 1px solid $shop-lightgray;
      border-radius: 4px;

      &::placeholder {
        width: 254px;
        color: $gray;

        @media screen and (max-width: $break-point) {
          width: 100%;
        }
      }

      @media screen and (max-width: $break-point) {
        width: 100%;
      }
    }

    .search-form-submit {
      width: 100px;
      height: 40px;
      background: $shop-blue;
      border: 1px solid $shop-blue;
      border-radius: 4px;
      color: #fff;
      margin-top: 8px;
      font-size: 15px;

      @media screen and (max-width: $break-point) {
        width: 100%;
      }
    }

    .word-and-search-btns {
      text-align: right;
      width: 100%;

      .search-form-submit {
        margin: 0;
        @media screen and (max-width: $break-point) {
          margin-top: 8px;
        }
      }
    }
  }

  .loading-box {
    background-color: #000;
    opacity: 0.8;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    .pg-performer-events--loader {
      position: fixed;
      top: 25%;
      left: 50%;
      z-index: 9999;
    }
  }
}
</style>
